<template>
  <v-container fluid>
    <!-- 🔍 Search + Print -->
    <SearchBar class="no-print" v-model="search" />

    <!-- <v-row class="no-print" align="center">
      <v-col cols="auto">
        <v-btn
          text
          rounded
          small
          color="blue-grey"
          dark
          @click="print"
        >
          <v-icon left>mdi-printer</v-icon>
          <span>Print</span>
        </v-btn>
      </v-col>
    </v-row> -->

    <!-- 📄 Card -->
    <v-card outlined class="rounded-xl mt-5">
      <ListTitle title="View Receipts" :hideCreate="true" />

      <v-card-text>
        <v-card flat class="rounded-xl" color="innerCard">
          <v-container grid-list-lg fluid>
            <v-row>
              <v-col cols="12" md="6">
                <DateTimePicker
                  :range="true"
                  v-model="dateTime"
                  :initStartDate="start"
                  :initEndDate="end"
                  @submit="getList"
                />
                <v-radio-group v-model="taxOption" row>
                  <v-radio label="Taxable" value="taxable" />
                  <v-radio label="Non Taxable" value="nonTaxable" />
                  <v-radio label="All" value="" />
                </v-radio-group>
              </v-col>

              <v-col cols="12" md="6" class="text-right" v-if="dateTime.start">
                <div class="font-weight-regular">
                  <div>
                    FROM: <span>{{ dateTime.start | moment("LLLL") }}</span>
                  </div>
                  <div>
                    TO: <span>{{ dateTime.end | moment("LLLL") }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-card-text>

      <v-card-text>
        <v-data-table
          id="printTable"
          :headers="headers"
          :items="invoices"
          :options.sync="options"
          :server-items-length="count"
          :loading="loading"
          class="table-header"
          :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
          :hide-default-footer="printActive"
        >
          <template v-slot:body="{ items }">
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.createdAt | moment("L LT") }}</td>
              <td>{{ item.Location && item.Location.name }}</td>
              <td>{{ item.localId }}</td>
              <td>
                {{ item.Contact ? item.Contact.fullName : "Walk-in customer" }}
              </td>
              <td class="text-right">{{ item.subTotal | currency }}</td>
              <td class="text-right">{{ item.taxTotal | currency }}</td>
              <td class="text-right">{{ item.grandTotal | currency }}</td>

              <!-- Actions -->
              <td class="text-right no-print">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="viewInvoice(item)">
                      <v-list-item-title>{{
                        $t("buttons.view")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="voidInvoice(item)">
                      <v-list-item-title>{{
                        $t("buttons.void")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- 🧾 Invoice dialog -->
      <v-dialog v-model="viewInvoiceDialog" fullscreen>
        <InvoiceReceipt
          v-if="viewInvoiceModal"
          :invoice="viewInvoiceModal"
          :actions="true"
          @close="viewInvoiceDialog = false"
        />
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import invoiceService from "../service";
import InvoiceReceipt from "../../Receipts/Invoice";
import DateTimePicker from "@/components/DateTimePicker";

export default {
  name: "invoice-list",
  props: ["ContactId", "hideHeader"],
  components: { InvoiceReceipt, DateTimePicker },
  data() {
    return {
      taxOption: "",
      start: this.$moment().startOf("day"),
      end: this.$moment().endOf("day"),
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      headers: [
        { text: this.$t("labels.date"), value: "createdAt" },
        { text: this.$t("labels.location"), value: "Location.name" },
        { text: this.$t("labels.invoice"), value: "localId" },
        { text: this.$t("labels.customer"), value: "Contact.fullName" },
        { text: this.$t("labels.subTotal"), value: "subTotal", align: "end" },
        { text: this.$t("labels.tax"), value: "taxTotal", align: "end" },
        {
          text: this.$t("labels.grandTotal"),
          value: "grandTotal",
          align: "end",
        },
        { text: "", value: "actions", sortable: false },
      ],
      search: "",
      invoices: [],
      count: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["createdAt"],
        sortDesc: [true],
      },
      viewInvoiceDialog: false,
      viewInvoiceModal: null,
      printActive: false,
    };
  },

  created() {
    if (this.$route.params && this.$route.params.date) {
      this.dateTime.start = this.$moment(
        this.$route.params.date.start
      ).toISOString();
      this.dateTime.end = this.$moment(
        this.$route.params.date.end
      ).toISOString();
      this.start = this.$moment(this.$route.params.date.start);
      this.end = this.$moment(this.$route.params.date.end);
    }
  },

  watch: {
    taxOption() {
      this.getList();
    },
    start() {
      this.getList();
    },
    end() {
      this.getList();
    },
    search() {
      if (this.search.length > 3 || this.search.length === 0) this.getList();
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("layout", ["drawerToggle"]),
    ...mapGetters("layout", ["getDrawer"]),

    async getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;
      const limit = itemsPerPage;
      const orderBy = [sortBy[0] || "createdAt", sortDesc[0] || false];

      try {
        const response = await invoiceService.getAll({
          limit,
          offset,
          search: this.search,
          start: this.dateTime.start,
          end: this.dateTime.end,
          orderBy,
          contactId: this.ContactId,
          includeLocation: true,
          tax: this.taxOption,
        });
        this.invoices = response.data;
        this.count = response.count;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    print() {
      if (this.getDrawer()) this.drawerToggle();
      this.printActive = true;
      setTimeout(() => {
        window.print();
        window.onafterprint = () => {
          this.printActive = false;
          this.drawerToggle();
        };
      }, 250);
    },

    async voidInvoice(invoice) {
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this! Card payments will not be voided on the customer's end.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.value) {
        this.$Progress.start();
        try {
          const res = await invoiceService.void(invoice.id);
          if (res.data) {
            this.$swal("Voided!", "Invoice was voided", "success");
            this.getList();
          }
        } catch (e) {
          this.$swal.fire({ icon: "error", title: e.data.message });
        } finally {
          this.$Progress.finish();
        }
      }
    },

    viewInvoice(invoice) {
      this.viewInvoiceModal = null;
      this.$Progress.start();
      invoiceService
        .getById(invoice.id)
        .then((response) => {
          this.viewInvoiceModal = response.data;
          this.viewInvoiceDialog = true;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.$toasted.error(error.data.message, {
            position: "top-right",
            duration: 2000,
          });
          this.$Progress.fail();
        });
    },
  },
};
</script>

<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
  #printTable {
    overflow: visible;
  }
  * {
    background: none !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
table.v-table tbody td {
  height: 25px !important;
}
</style>